import React, { useState } from "react";
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";

const socialLinks = [
    {
        label: "Facebook",
        icon: FaFacebookF,
        url: "https://www.facebook.com/AQinv",
    },
    {
        label: "Instagram",
        icon: FaInstagram,
        url: "https://www.instagram.com/aequitas.invest/",
    },
    {
        label: "LinkedIn",
        icon: FaLinkedinIn,
        url: "https://www.linkedin.com/company/aequitasinvest/posts/?feedView=all",
    },
];

const columns = [
    {
        title: "Investors",
        links: [
            ["FINRA Disclosure", "/docs/finra_disclosure_10_2026.pdf"],
            ["Investor FAQ", "/faq/public/investors"],
            ["Investor Dashboard", "/login"],
        ],
    },
    {
        title: "Entrepreneur",
        links: [
            ["Entrepreneur FAQ", "/faq/public/entrepreneurs"],
            ["Entrepreneur Dashboard", "/login"],
            ["Affiliated Partners", "/resources"],
        ],
    },
    {
        title: "Company",
        links: [
            ["About Us", "/mission"],
            ["News & Updates", "/news"],
            ["Privacy Policy", "/docs/privacy_policy_10_2026.pdf"],
            ["Terms of Use", "/docs/terms_of_use_10_2026.pdf"],
            ["Contact Us", "/contact-us"],
            ["DMCA Policy", "/docs/dmca_policy_10_2026.pdf"],
        ],
    },
];

const Footer = () => {
    const [email, setEmail] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [subscriptionError, setSubscriptionError] = useState("");

    const subscribe = async (event) => {
        event.preventDefault();
        setIsSubmitting(true);
        setSubscriptionError("");

        try {
            const response = await fetch(
                `${process.env.REACT_APP_BACKEND_URL}/api/alerts/subscribe`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ email: email.trim() }),
                },
            );
            const data = await response.json().catch(() => ({}));

            if(!response.ok) {
                setSubscriptionError(
                    data.error || "Subscription failed. Please try again.",
                );
                return;
            }

            window.location.href =
                "/subscribe-alerts?subscribed=true#subscription-confirmed";
        } catch{
            setSubscriptionError("Subscription failed. Please try again.");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <footer className="bg-navy text-paper">
            <div className="mx-auto max-w-[1600px] px-6 py-14 md:px-12 lg:px-16 lg:py-16">
                <div className="grid gap-12 md:grid-cols-12 md:gap-8 lg:gap-12">
                    <div className="md:col-span-3">
                        <a href="/" className="inline-block" aria-label="AQi home">
                            <img
                                src="/images/aqi-logo-white.png"
                                alt="AQi"
                                className="h-10 w-auto"
                            />
                        </a>
                        <p className="mt-6 max-w-[25ch] text-[15px] leading-relaxed text-paper/65">
                            A Reg CF funding portal, 100% women founded and owned.
                        </p>
                    </div>

                    {columns.map((column) => (
                        <div key={column.title} className="md:col-span-2">
                            <h2 className="font-mono text-[10px] uppercase tracking-[0.22em] text-paper/50">
                                {column.title}
                            </h2>
                            <ul className="mt-5 space-y-4 text-[15px] text-paper/70">
                                {column.links.map(([label, href]) => (
                                    <li key={label}>
                                        <a
                                            href={href}
                                            className="transition-colors hover:text-gold"
                                        >
                                            {label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}

                    <div className="md:col-span-3">
                        <h2 className="font-mono text-[10px] uppercase tracking-[0.22em] text-paper/50">
                            Subscribe to our eNewsletter
                        </h2>
                        <p className="mt-5 max-w-[34ch] text-[15px] leading-relaxed text-paper/65">
                            Get Reg CF insights, founder stories, and platform updates.
                        </p>
                        <form
                            onSubmit={subscribe}
                            className="mt-6 flex flex-col gap-3 sm:flex-row md:flex-col xl:flex-row"
                        >
                            <input
                                type="email"
                                value={email}
                                onChange={(event) => setEmail(event.target.value)}
                                required
                                placeholder="Email address"
                                className="min-w-0 flex-1 rounded-[7px] border border-paper/10 bg-paper/5 px-4 py-3 text-sm text-paper outline-none placeholder:text-paper/40 focus:border-gold"
                            />
                            <button
                                type="submit"
                                disabled={isSubmitting}
                                className="rounded-[7px] bg-gold px-5 py-3 text-sm font-bold text-navy transition-colors hover:brightness-105 disabled:cursor-not-allowed disabled:opacity-60"
                            >
                                {isSubmitting ? "Subscribing..." : "Subscribe"}
                            </button>
                        </form>
                        {subscriptionError && (
                            <p className="mt-3 text-sm text-red-300" role="alert">
                                {subscriptionError}
                            </p>
                        )}
                        <div className="mt-6 flex justify-center gap-3">
                            {socialLinks.map(({ label, icon: Icon, url }) => (
                                <a
                                    key={label}
                                    href={url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label={`Follow AQi on ${label}`}
                                    className="flex h-9 w-9 items-center justify-center rounded-full bg-paper text-navy transition-colors hover:bg-gold"
                                >
                                    <Icon size={18} aria-hidden="true" />
                                </a>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="mt-14 border-t border-paper/10 pt-6 text-xs leading-relaxed text-paper/45">
                    © 2026 Aequitas Invest Inc. All rights reserved. Aequitas
                    Invest Inc. is a funding portal registered with the SEC and
                    a member of FINRA (SEC File No. 7-483).
                </div>
            </div>
        </footer>
    );
};

export default Footer;
